// extracted by mini-css-extract-plugin
module.exports = {"referencesContainer":"ob_mKqDnX","separator":"ob_bQefXS","references":"ob_wmN02R"};